import api from '../lib/api';

export const FETCH_MARKET_LOCATIONS = 'FETCH_MARKET_LOCATIONS';
export const LOCATIONS_LOADING = 'LOCATIONS_LOADING';

export default {
  fetchLocations(query) {
    return (dispatch) => {
      dispatch({ type: LOCATIONS_LOADING, payload: true });

      return api.getLocations(query)
        .then((locations) => {
          dispatch({ type: FETCH_MARKET_LOCATIONS, payload: locations });
        })
        .then(() => {
          dispatch({ type: LOCATIONS_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: LOCATIONS_LOADING, payload: false });
        });
    };
  },
  createLocation(location) {
    return () => api.createLocation(location);
  },
  updateLocation(location, locationId) {
    return () => api.updateLocation(location, locationId);
  },
  bulkUploadLocations(marketId, hubData, overwrite) {
    return () => api.bulkUploadLocations(marketId, hubData, overwrite);
  },
  bulkEditLocations(locationIds, newCapacity, newStatus) {
    return () => api.bulkEditLocations(locationIds, newCapacity, newStatus);
  },
};
